import { useMutation } from 'react-query'

// Services
import { RevokeIntegrationToken } from 'services/api/Auth'

export default () => {
  const {
    mutate: revokeIntegrationToken,
    data: revokeIntegrationTokenData,
    error: revokeIntegrationTokenError,
    isLoading: isRevokeIntegrationTokenLoading,
    isSuccess: isRevokeIntegrationTokenSuccess,
    isError: isRevokeIntegrationTokenError,
  } = useMutation(RevokeIntegrationToken)

  // credentials and isloggedin are set in the loginform component

  return {
    revokeIntegrationToken,
    revokeIntegrationTokenData,
    revokeIntegrationTokenError,
    isRevokeIntegrationTokenLoading,
    isRevokeIntegrationTokenSuccess,
    isRevokeIntegrationTokenError,
  }
}
